import { useSelector } from "react-redux";
import RankingPrincipal from "./principal/RankingPrincipal.js";
import RankingTeacher from "./teacher/RankingTeacher.js";
import RankingStudent from "./student/RankingStudent.js";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import RankingParent from "./parent/RankingParent.js";

function Ranking() {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <RankingPrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <RankingTeacher />;
    }
    if (state.auth.user.is_student) {
      return <RankingStudent />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <RankingParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
}

export default Ranking;
